import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import ListTransfer from "components/transfer/ListTransfer";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { gettingProfileCategory, updatingProfileCategory } from "utils/CategoryReport";

const AssignCategory = ({open, setOpen, profileId}) => {
    const { t } = useTranslation();

    const [loadingData, setLoadingData] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selected, setSelected] = useState([]);

    const closing = () => {
        setOpen(false);
        setLoadingData(false);
        setLoadingUpdate(false);
        setCategories([]);
        setSelected([]);
    }

    useEffect(() => {
        if(open){
            gettingProfileCategory(setLoadingData, profileId, setSelected, setCategories)
        }

    }, [open])

    return (
        <>
            <Dialog
                open={open}
                onClose={() => closing}
            >
                <DialogTitle>
                    <Typography variant='body3'>{ 'Asignar categoria' }</Typography>
                </DialogTitle>

                <DialogContent dividers>
                    <ListTransfer
                        loading={loadingData}
                        allItems={categories}
                        right={selected}
                        setRight={setSelected}
                        textLeft={'Categorias'}
                        textRight={'Categorias asignadas'}
                        textSelected={'Seleccionadas'}
                    />
                </DialogContent>

                <DialogActions sx={{ pr: 3}}>
                    <LoadingButton
                        variant='contained'
                        disableElevation
                        onClick={() => {
                            updatingProfileCategory(setLoadingUpdate, profileId, selected, closing)
                        }}
                        loading={loadingUpdate}
                        disabled={loadingUpdate}
                    >
                        {t('settings.paycodes.table.modals.add.buttons.save')}
                    </LoadingButton>

                    <Button variant='contained' disableElevation color='error' onClick={() => closing()}>
                        {t('settings.paycodes.table.modals.add.buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export {
    AssignCategory
}